

















import { Component } from 'vue-property-decorator';
import FormSwitch from '@/components/Form/InputComponents/FormSwitch.vue';
import Agreements from '@/components/Billing/Agreements.vue';
import CustomerSelection from '@/components/Billing/CustomerSelection.vue';
import BillingAddress from '@/components/Billing/BillingAddress.vue';
import Validatable from '@/components/Validatable.vue';
import { NamedOption } from '@/util/NamedOption';
import { namespace } from 'vuex-class';
import { Store } from '@/enums/Store';
import Member from '@/store/member';

const MemberStore = namespace(Store.MEMBER);

@Component({
  components: {
    BillingAddress,
    CustomerSelection,
    Agreements,
    FormSwitch
  }
})
export default class BillingForm extends Validatable {
  switchOption!: NamedOption;
  @MemberStore.State('members') members!: Member[];

  isInvoiceRecipientCustomer = true;
  showSwitch = true;

  created(): void {
    if (this.members.length == 1) {
      this.showSwitch = false;
    }

    this.switchOption = new NamedOption(
      this.$t('make-invoice-recipient-customer').toString(),
      true,
      'make-invoice-recipient-customer'
    );
  }
}
